if (!customElements.get('quick-add-bulk')) {
  customElements.define(
    'quick-add-bulk',
    class QuickAddBulk extends BulkAdd {
      constructor() {
        super();
        this.cart = document.querySelector('cart-drawer');
        this.quantity = this.querySelector('quantity-input');
        this.addEventListener('click', (event) => {
          if (event.target.closest('.qv_cart_btn')) this.onAddBtnClick(event);
        });
        const debouncedOnChange = debounce((event) => {
          if (parseInt(event.target.value) === 0) {
            this.startQueue(event.target.dataset.index, parseInt(event.target.value));
            if(this.querySelector(".qv_cart_btn")) this.querySelector(".qv_cart_btn").classList.remove("hidden");
            if(this.querySelector(".qv_add_input")) this.querySelector(".qv_add_input").classList.add("hidden");
          } else {
            this.validateQuantity(event);
          }
        }, ON_CHANGE_DEBOUNCE_TIMER);

        this.addEventListener('change', debouncedOnChange.bind(this));
        this.listenForActiveInput();
        this.listenForKeydown();
        this.lastActiveInputId = null;
        const pageParams = new URLSearchParams(window.location.search);
        window.pageNumber = decodeURIComponent(pageParams.get('page') || '');
      }

      onAddBtnClick(event){
        event?.preventDefault();
        if(this.querySelector('button[name="plus"]')){
          const button = this.querySelector('button[name="plus"]');
          const clickEvent = new MouseEvent('click', {
            bubbles: true,
            cancelable: true,
            view: window
          });

          button.dispatchEvent(clickEvent);
          if(this.querySelector(".qv_cart_btn")) this.querySelector(".qv_cart_btn").classList.add("hidden");
          if(this.querySelector(".qv_add_input")) this.querySelector(".qv_add_input").classList.remove("hidden");
        }
      }

      connectedCallback() {
        this.cartUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, (event) => {
          if (
            event.source === 'quick-add' ||
            (event.cartData.items && !event.cartData.items.some((item) => item.id === parseInt(this.dataset.index))) ||
            (event.cartData.variant_id && !(event.cartData.variant_id === parseInt(this.dataset.index)))
          ) {
            return;
          }
          // If its another section that made the update
          this.onCartUpdate().then(() => {
            this.listenForActiveInput();
            this.listenForKeydown();
          });
        });
      }

      disconnectedCallback() {
        if (this.cartUpdateUnsubscriber) {
          this.cartUpdateUnsubscriber();
        }
      }

      getInput() {
        return this.querySelector('quantity-input input');
      }

      selectProgressBar() {
        return this.querySelector('.progress-bar-container');
      }

      listenForActiveInput() {
        if (!this.classList.contains('hidden')) {
          this.getInput()?.addEventListener('focusin', (event) => event.target.select());
        }
        this.isEnterPressed = false;
      }

      listenForKeydown() {
        this.getInput()?.addEventListener('keydown', (event) => {
          if (event.key === 'Enter') {
            this.getInput().blur();
            this.isEnterPressed = true;
          }
        });
      }

      cleanErrorMessageOnType(event) {
        event.target.addEventListener(
          'keypress',
          () => {
            event.target.setCustomValidity('');
          },
          { once: true }
        );
      }

      onCartUpdate() {
        return new Promise((resolve, reject) => {
          if (this.closest('.collection')) {
            fetch(`${this.getSectionsUrl()}?section_id=${this.closest('.collection').dataset.id}`)
              .then((response) => response.text())
              .then((responseText) => {
                const html = new DOMParser().parseFromString(responseText, 'text/html');
                const sourceQty = html.querySelector(
                  `#quick-add-bulk-${this.dataset.id}-${this.closest('.collection').dataset.id}`
                );
                if (sourceQty) {
                  this.innerHTML = sourceQty.innerHTML;
                }
                resolve();
              })
              .catch((e) => {
                console.error(e);
                reject(e);
              });
          }
        });
      }

      updateMultipleQty(items) {
        this.selectProgressBar().classList.remove('hidden');

        const ids = Object.keys(items);
        const body = JSON.stringify({
          updates: items,
          sections: this.getSectionsToRender().map((section) => section.section),
          sections_url: this.getSectionsUrl(),
        });

        fetch(`${routes.cart_update_url}`, { ...fetchConfig(), ...{ body } })
          .then((response) => {
            return response.text();
          })
          .then((state) => {
            const parsedState = JSON.parse(state);
            if (parsedState.errors || parsedState.status) {
              throw new Error(parsedState.description || parsedState.errors || window.cartStrings.error);
            }
            this.renderSections(parsedState, ids);
            document.querySelectorAll('quick-add-bulk').forEach((card) => {
              const input = card.querySelector('quantity-input input');
              if (!input) return;
              const quantity = parsedState.items.filter((item) => String(item.variant_id) === String(input.dataset.index)).reduce((sum, item) => sum + item.quantity, 0);
              input.value = quantity;
              input.setAttribute('value', quantity);
              card.querySelector('.qv_cart_btn')?.classList.toggle('hidden', quantity > 0);
              card.querySelector('.qv_add_input')?.classList.toggle('hidden', quantity === 0);
            });
            document.querySelector('.quick-notify')?.classList.toggle('active', parsedState.item_count > 0 && !document.body.classList.contains('page-cart'));
            publish(PUB_SUB_EVENTS.cartUpdate, { source: 'quick-add', cartData: parsedState });
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {

            this.selectProgressBar().classList.add('hidden');
            this.requestStarted = false;
          });
      }

      getSectionsToRender() {
        const collection = this.closest('.collection-quick-add-bulk');
        return [
          ...(collection ? [{
            id: this.id,
            section: collection.dataset.id,
            selector: `#${this.id}`,
          }] : []),
          {
            id: 'cart-icon-bubble',
            section: 'cart-icon-bubble',
            selector: '.shopify-section',
          },
          {
            id: 'cart-icon-quick',
            section: 'cart-icon-quick',
            selector: '.shopify-section',
          },
          {
            id: 'CartDrawer',
            selector: '#CartDrawer',
            section: 'cart-drawer',
          },
        ];
      }

      renderSections(parsedState, ids) {
        const intersection = this.queue.filter((element) => ids.includes(element.id));
        if (intersection.length !== 0) return;
        this.getSectionsToRender().forEach((section) => {
          const sectionElement = document.getElementById(section.id);
          if (
            sectionElement &&
            sectionElement.parentElement &&
            sectionElement.parentElement.classList.contains('drawer')
          ) {
            parsedState.items.length > 0
              ? sectionElement.parentElement.classList.remove('is-empty')
              : sectionElement.parentElement.classList.add('is-empty');

            setTimeout(() => {
              document.querySelector('#CartDrawer-Overlay').addEventListener('click', this.cart.close.bind(this.cart));
            });
          }
          const elementToReplace =
            sectionElement && sectionElement.querySelector(section.selector)
              ? sectionElement.querySelector(section.selector)
              : sectionElement;
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );
          }
        });

        if (this.isEnterPressed) {
          this.querySelector(`#Quantity-${this.lastActiveInputId}`).select();
        }

        this.listenForActiveInput();
        this.listenForKeydown();
      }
    }
  );
}
